import { authenticationInterceptor } from "@interceptors/auth.http-interceptor";
import { gobernanzaInterceptor } from "@interceptors/gobernanza.http-interceptor";
import * as Sentry from "@sentry/angular";
import { recoverFromChunkLoadError } from "@utils/chunk-load-recovery.utils";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  type ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withNavigationErrorHandler,
  withViewTransitions,
} from "@angular/router";

import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: "es-CL" },
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler(recoverFromChunkLoadError),
      withViewTransitions()
    ),
    provideHttpClient(
      withInterceptors([authenticationInterceptor, gobernanzaInterceptor])
    ),
    provideZonelessChangeDetection(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
